module.exports = __webpack_public_path__ + "img/image57.1344f997.png";